import 'css-chunksrc/feature/check-item-detail/CheckItemDetailNote.module.scss';export default {
  "root": "CheckItemDetailNote_root",
  "headingRoot": "CheckItemDetailNote_headingRoot",
  "headingText": "CheckItemDetailNote_headingText",
  "input": "CheckItemDetailNote_input"
};